import { getChannelList } from '../../services/articleSubmissions/edit';
import {
  getPublishList,
  getNewsTop,
  getNewsRemove,
  getPushNews,
  getNewsMovement,
  getUpOrDownList,
  getLabelList,
  getUserIdentity,
  getPushNewsToSchool,
  upNewsToEdu,
  getNewsMove,
} from '../../services/articlePublished/articleLists';

const initState = {};

export default {
  namespace: 'artcleLists',
  state: initState,
  effects: {
    *fetchChannelList({ params }, { call }) {
      try {
        const response = yield call(getChannelList, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchPublishList({ params }, { call }) {
      try {
        const response = yield call(getPublishList, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchIdentity({ params }, { call }) {
      try {
        const response = yield call(getUserIdentity, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchUpOrDownList({ params }, { call }) {
      try {
        const response = yield call(getUpOrDownList, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchNewsTop({ params }, { call }) {
      try {
        const response = yield call(getNewsTop, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchNewsMove({ params }, { call }) {
      try {
        const response = yield call(getNewsMove, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchNewsRemove({ params }, { call }) {
      try {
        const response = yield call(getNewsRemove, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchPushNews({ params }, { call }) {
      try {
        const response = yield call(getPushNews, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchPushNewsToSchool({ params }, { call }) {
      try {
        const response = yield call(getPushNewsToSchool, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchNewsMovement({ params }, { call }) {
      try {
        const response = yield call(getNewsMovement, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchLabelList({ params }, { call }) {
      try {
        const response = yield call(getLabelList, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchUpToEdu({ params }, { call }) {
      try {
        const response = yield call(upNewsToEdu, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
  },

  reducers: {
    saveState(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return {
        ...initState,
      };
    },
  },
};
